import { Link } from "react-router-dom";

const services = [
  {
    icon: "ri-home-4-line",
    title: "Vaciado de pisos y casas",
    desc: "Vaciado completo de viviendas en Girona: pisos, casas, áticos y bajos. Retiramos absolutamente todo con gestión responsable de residuos.",
    color: "#ff0000",
  },
  {
    icon: "ri-store-2-line",
    title: "Vaciado de locales comerciales",
    desc: "Vaciado de oficinas, tiendas, naves y locales en Girona y comarca. Servicio rápido para que puedas retomar tu actividad cuanto antes.",
    color: "#ff0000",
  },
  {
    icon: "ri-truck-line",
    title: "Retirada de muebles",
    desc: "Recogida y retirada de muebles y electrodomésticos. Servicio mínimo de una furgoneta completa. Sin recogidas de piezas sueltas.",
    color: "#ff0000",
  },
  {
    icon: "ri-heart-pulse-line",
    title: "Limpieza síndrome de Diógenes",
    desc: "Limpieza extrema y desinfección de viviendas con acumulación severa. Actuamos con total discreción y respeto hacia las personas afectadas.",
    color: "#ff0000",
  },
  {
    icon: "ri-paint-brush-line",
    title: "Pintura final",
    desc: "Pintura interior de pisos y locales para preparar la venta o el alquiler. Acabados profesionales que aumentan el valor del inmueble.",
    color: "#ff0000",
  },
];

export default function ServicesGrid() {
  return (
    <section className="py-20 md:py-28 bg-[#f9f5f5]" style={{ fontFamily: "'Montserrat', sans-serif" }}>
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="text-center mb-14">
          <span className="inline-block text-xs font-700 text-[#b30000] uppercase tracking-widest mb-3" style={{ fontWeight: 700 }}>
            Nuestros servicios
          </span>
          <h2 className="text-3xl md:text-4xl font-800 text-[#330000] mb-4" style={{ fontWeight: 800 }}>
            Todo lo que necesitas para vaciar y renovar
          </h2>
          <p className="text-gray-600 max-w-2xl mx-auto text-base leading-relaxed">
            Ofrecemos un servicio integral en Girona y comarca: desde el{" "}
            <a
              href="https://vaciadoszafa.com.es/vaciado-de-pisos-girona/"
              rel="nofollow"
              target="_blank"
              className="underline hover:text-[#cc0000] transition-colors duration-200"
            >
              vaciado completo
            </a>
            {" "}hasta la pintura final, para que el inmueble quede listo para vender o alquilar. Sin necesidad de buscar otros profesionales.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 md:gap-8">
          {services.map((s) => (
            <div
              key={s.title}
              className="bg-white rounded-2xl p-8 cursor-pointer group transition-all duration-300 hover:-translate-y-2"
              style={{ border: "1px solid rgba(255,0,0,0.08)" }}
            >
              <div className="w-14 h-14 flex items-center justify-center rounded-xl bg-[#ff0000]/10 mb-5 group-hover:bg-[#ff0000] transition-colors duration-300">
                <i className={`${s.icon} text-2xl text-[#b30000] group-hover:text-white transition-colors duration-300`}></i>
              </div>
              <h3 className="text-lg font-700 text-[#330000] mb-3" style={{ fontWeight: 700 }}>{s.title}</h3>
              <p className="text-sm text-gray-600 leading-relaxed mb-5">{s.desc}</p>
              <Link
                to="/servicios"
                className="inline-flex items-center gap-1.5 text-sm font-600 text-[#b30000] hover:gap-3 transition-all duration-200 cursor-pointer"
                style={{ fontWeight: 600 }}
              >
                Saber más <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/servicios"
            className="inline-flex items-center gap-2 bg-[#330000] text-white px-8 py-4 rounded-full text-sm font-700 whitespace-nowrap cursor-pointer transition-all duration-300 hover:bg-[#ff0000] hover:scale-105"
            style={{ fontWeight: 700 }}
          >
            Ver todos los servicios <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}
